<template>
<div class="panel">
  <div class="panel-header">
    <slot name='header'>
      <van-nav-bar :title="title" :left-arrow='showback' @click-left="$back" :right-text='righttext' @click-right="$emit('rightclick')" />
    </slot>
  </div>
  <div class="panel-content" v-if='!error'>
    <slot>

    </slot>
  </div>
  <div class="panel-error" v-else>
    <slot name='error'>
      <van-empty image="/static/images/star-grey.png" :description="error">
      </van-empty>
    </slot>
  </div>
  <slot name='else'>
  </slot>
</div>
</template>
<script>
export default {
  name: 'panel',
  props: {
    title: {
      type: String,
      default: ''
    },
    showback: {
      type: Boolean,
      default: false
    },
    righttext: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang='less'>
.panel {
    color: @fontcolor1;
    width: 100%;
    height: 100%;
    padding-top: 46px;
    background-color: #f7f8fa;
    .panel-header {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: linear-gradient(to right,@main 0%,@primary 100%);
        .van-nav-bar {
            background: none;
            .van-nav-bar__title {
                color: white;
                font-size: 18px;
            }
            .van-icon-arrow-left {
                color: white;
                font-size: 20px;
            }
        }
    }
    .panel-content {
        width: 100%;
        height: 100%;
        overflow: auto;
        .scroll-slot {
            width: 100%;
            height: 100%;
            overflow-y: auto;
        }
    }
    .panel-bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 5px;
        z-index: 2;
    }
    .panel-error {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .van-empty {
            padding-bottom: 200px;
        }
    }
}
</style>
